import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, key } = useLocation();

  useEffect(() => {
    // Scroll window to top instantly on route or location key change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }

    // Reset scroll on any page container elements
    const containers = document.querySelectorAll(
      ".tn-page-wrapper, .tn-page-content, main, #root"
    );
    containers.forEach((container) => {
      if (container) {
        container.scrollTop = 0;
      }
    });
  }, [pathname, key]);

  return null;
}
